import { Swiper } from 'swiper';
import { Navigation, Pagination, Controller, Autoplay } from 'swiper/modules';

export default config => ({
    imagesSwiper: null,
    productsSwiper: null,
    label: config.label || '',
    currency: config.currency,
    listId: config.listId || 'featured-collection-carousel',

    init() {
        this.$nextTick(() => {
            this.initSwiper();
        });
    },

    initSwiper() {
        // Check if we have both carousels (available collection) or just one (not available)
        const hasImagesCarousel = this.$refs.imagesCarousel;
        const hasFeaturedCarousel = this.$refs.featuredCarousel;

        if (hasImagesCarousel && hasFeaturedCarousel) {
            // Initialize linked carousels for available collections
            this.initLinkedCarousels();
        } else if (hasFeaturedCarousel) {
            // Initialize single products carousel
            this.initProductsCarousel();
        }
    },

    initLinkedCarousels() {
        // Check if we're on a large screen (lg breakpoint = 1024 px)
        const isLargeScreen = window.innerWidth >= 1024;

        // Initialize images carousel (left) - only on large screens
        // No autoplay here - it will be controlled by the products carousel
        if (isLargeScreen && this.$refs.imagesCarousel) {
            this.imagesSwiper = new Swiper(this.$refs.imagesCarousel, {
                modules: [Controller],
                slidesPerView: 1,
                spaceBetween: 0,
                allowTouchMove: true,
                speed: 800,
            });
        }

        // Initialize products carousel (right) - always initialize
        if (this.$refs.featuredCarousel) {
            this.productsSwiper = new Swiper(this.$refs.featuredCarousel, {
                modules: isLargeScreen && this.imagesSwiper ? [Navigation, Pagination, Controller, Autoplay] : [Navigation, Pagination, Autoplay],
                slidesPerView: 1,
                spaceBetween: 0,
                navigation: {
                    nextEl: this.$refs.next,
                    prevEl: this.$refs.previous,
                },
                pagination: {
                    el: this.$refs.pagination,
                    type: 'bullets',
                    clickable: true,
                },
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                speed: 800,
                on: {
                    init: () => {
                        this.sendImpressionEvent();
                    },
                },
            });

            // Link the carousels bidirectionally only if both are initialized
            if (this.imagesSwiper && this.productsSwiper) {
                this.imagesSwiper.controller.control = this.productsSwiper;
                this.productsSwiper.controller.control = this.imagesSwiper;
            }
        }
    },

    initProductsCarousel() {
        this.productsSwiper = new Swiper(this.$refs.featuredCarousel, {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            spaceBetween: 0,
            navigation: {
                nextEl: this.$refs.next,
                prevEl: this.$refs.previous,
            },
            pagination: {
                el: this.$refs.pagination,
                type: 'bullets',
                clickable: true,
            },
            on: {
                init: () => {
                    this.sendImpressionEvent();
                },
            },
        });
    },

    sendImpressionEvent() {
        if (typeof gtag === 'undefined' || typeof dataLayer === 'undefined') {
            return;
        }

        const items = [];
        const slides = this.$refs.featuredCarousel.querySelectorAll('.swiper-slide');

        slides.forEach((slide, index) => {
            const itemId = slide.dataset.itemId;
            const itemName = slide.dataset.itemName;

            if (itemId && itemName) {
                items.push({
                    item_id: itemId,
                    item_name: itemName,
                    item_list_id: this.listId,
                    item_list_name: this.label,
                    index: index,
                });
            }
        });

        if (items.length > 0) {
            gtag('event', 'view_item_list', {
                item_list_id: this.listId,
                item_list_name: this.label,
                items: items,
            });
        }
    },

    onItemClick(event) {
        const link = event.target.closest('a[href*="/products/"]');
        if (!link) return;

        const slide = link.closest('.swiper-slide');
        if (!slide) return;

        const itemId = slide.dataset.itemId;
        const itemName = slide.dataset.itemName;
        const index = Array.from(slide.parentNode.children).indexOf(slide);

        if (typeof gtag !== 'undefined' && itemId && itemName) {
            gtag('event', 'select_item', {
                item_list_id: this.listId,
                item_list_name: this.label,
                items: [{
                    item_id: itemId,
                    item_name: itemName,
                    item_list_id: this.listId,
                    item_list_name: this.label,
                    index: index,
                }, ],
            });
        }
    },

    destroy() {
        if (this.imagesSwiper) {
            this.imagesSwiper.destroy(true, true);
            this.imagesSwiper = null;
        }
        if (this.productsSwiper) {
            this.productsSwiper.destroy(true, true);
            this.productsSwiper = null;
        }
    },
});
